// The "looked up:" chips under an AI answer (src/pages/Chat.jsx SourceLinks). A short answer keeps its sources as they
// come (the pages, the records it used, the cited files). A summary - the morning briefing, or any answer that read more
// than MAX_CHIPS things - shows only the pages it read (Dashboard · Maintenance · Calendar · To Do), each once, then the
// cited files if there is room: never every task name.
export const MAX_CHIPS = 6
export const isBriefing = text => /\b(morning|fleet) briefing\b/i.test(String(text || ''))

export function chipSources(sources, { summary = false } = {}) {
  const list = (sources || []).filter(s => s && String(s.label || '').trim())
  if (!summary && list.length <= MAX_CHIPS) return list
  const seen = new Set(), pages = [], files = []
  const add = (bucket, key, s) => { if (seen.has(key)) return; seen.add(key); bucket.push(s) }
  for (const s of list) {
    const label = String(s.label).trim()
    if (s.url) add(files, 'u|' + s.url, { ...s, label })
    else if (s.cite) add(files, 'c|' + label.toLowerCase(), { ...s, label })   // a cited document without a file link stays a chip
    else if (s.page && !s.query && !s.open) add(pages, 'p|' + s.page + '|' + label.toLowerCase(), { label, page: s.page })
  }
  // the documents an answer cites are never pushed out by the pages it read
  const cited = files.filter(s => s.cite), other = files.filter(s => !s.cite)
  const keep = cited.slice(0, MAX_CHIPS)
  return pages.slice(0, MAX_CHIPS - keep.length).concat(keep, other).slice(0, MAX_CHIPS)
}
